// extracted by mini-css-extract-plugin
export default {"close-button":"PendingNotification_close-button__77Ko4"};